import { useTheme } from "@/theme/theme-provider";
import { Toaster as Sonner } from "sonner";
import { CircleCheck, InfoIcon, MessageCircleWarning, CircleAlert, Loader2 } from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CircleCheck className="text-success mr-2" />,
        info: <InfoIcon className="text-primary mr-2" />,
        warning: <MessageCircleWarning className="text-yellow-400 mr-2" />,
        error: <CircleAlert className="text-destructive mr-2" />,
        loading: <Loader2 />,
      }}
      position="bottom-center"
      theme={theme as ToasterProps["theme"]}
      toastOptions={{
        classNames: {
          content: "ml-2",
          toast: `group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg`,
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
